



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Schedules, User } from '@/store';
import { Types } from '@/modules/API';
import PropEditor from '@/components/PropEditor.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';

@Component({ components: { PropEditor, ConfirmDialog, MessageDialog } })
class DeleteCurve extends Vue {
  @Prop({ type: String, required: true }) curveId;

  @User.State('project') project;
  @Schedules.State('schedules') schedules;
  @Schedules.State('userCurves') userCurves;
  @Schedules.Action('deleteCurve') deleteCurve;
  @Schedules.Action('runSchedulerInServer') runSchedulerInServer;

  in_use_message = 'You must remove this curve from the following schedules before delete';
  $refs!: { propEditor: InstanceType<typeof PropEditor> };

  /** Names of the schedules still using this curve - empty means it is safe to delete. */
  get schedules_in_use() {
    return (this.schedules || [])
      .filter((schedule) => Array.isArray(schedule.curves) &&
        schedule.curves.some((date_curve) => date_curve.id === this.curveId))
      .map((schedule) => schedule.name);
  }

  async removeCurve() {
    // Drops it from the store first, so what gets persisted below is the remaining list.
    await this.deleteCurve(this.curveId);
    this.$refs.propEditor.save(this.userCurves, {
        name: 'dashboard.curves',
        objectID: this.project.id,
        objectType: Types.PROJECTS
      },
      () => {
        this.runSchedulerInServer();
        this.$emit('deleted', this.curveId);
      },
      'Curve Deleted Successfully'
    );
  }
}

export default DeleteCurve;
